import React, { useMemo, useState } from "react";
import { Link, IfPermitted } from "components/common";
import { DropdownButton, MenuItem, BootstrapModalConfirm, DeleteMenuItem } from "components/bootstrap";
import ForwarderRoutes from "forwarder/Routes";
import InputProfileAssignForm from "./InputProfileAssignForm";
import EditInputProfileForm from "./EditInputProfileForm";
import { InputProfilesActions } from "../stores/InputProfilesStore";
const InputProfileEntry = ({
  inputProfile,
  forwarderCount,
  forwarders,
  onForwardersAssign,
  onInputProfileUpdate
}) => {
  const { id, title, description } = inputProfile;
  const [showModal, setShowModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const _openConfirmation = () => setShowModal(true);
  const _closeConfirmation = () => setShowModal(false);
  const assignedForwarders = useMemo(
    () => forwarders.filter((f) => f.input_profile_id === inputProfile.id),
    [forwarders, inputProfile]
  );
  const _onDelete = () => {
    InputProfilesActions.delete(id);
  };
  return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.PROFILE.details(id) }, title)), /* @__PURE__ */ React.createElement("td", null, description), /* @__PURE__ */ React.createElement("td", null, forwarderCount), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "inputprofiles:edit" }, /* @__PURE__ */ React.createElement(
    EditInputProfileForm,
    {
      inputProfile,
      onSave: onInputProfileUpdate,
      buttonBsStyle: "primary",
      buttonBsSize: "xsmall"
    }
  )), "\xA0", /* @__PURE__ */ React.createElement("span", { key: "split-button-default" }, /* @__PURE__ */ React.createElement(DropdownButton, { bsSize: "xsmall", id: "input-profile-action", title: "Choose action", bsStyle: "default", pullRight: true }, /* @__PURE__ */ React.createElement(MenuItem, { eventKey: "1", href: ForwarderRoutes.PROFILE.details(id) }, "View"), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarders:edit" }, /* @__PURE__ */ React.createElement(MenuItem, { eventKey: "3", onClick: () => setShowAssignModal(true) }, "Assign to Forwarders")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "inputprofiles:delete" }, forwarderCount > 0 ? /* @__PURE__ */ React.createElement(DeleteMenuItem, { eventKey: "3", disabled: true }, "Delete disabled: still in use") : /* @__PURE__ */ React.createElement(DeleteMenuItem, { eventKey: "3", onClick: _openConfirmation })))), showAssignModal && /* @__PURE__ */ React.createElement(
    InputProfileAssignForm,
    {
      showModal: showAssignModal,
      onClose: () => setShowAssignModal(false),
      inputProfileId: id,
      assignedForwarders,
      forwarders,
      onForwardersAssign
    }
  ), showModal && /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal,
      title: "Delete Input profile",
      onConfirm: _onDelete,
      onCancel: _closeConfirmation
    },
    `Are you sure you want to delete Input Profile "${title}"? This will delete all 
            inputs in this input profile.`
  )));
};
export default InputProfileEntry;
